import BleDeviceService from '../../services/BleDeviceService';
import moment from 'moment';


export default {
	state: {
		rssi: null,
		bleDevice: null,
		message: "",
		error: "",
		// connecting: false
	},
	actions: {
		async bleConnect({state, commit, dispatch}, deviceId){

			let advertisement;
			let bleDevice;

			if(typeof ble === 'undefined') throw Error('Bluetooth not available');
			// if(state.connecting) throw Error('Already trying to connect');

			BleDeviceService.disconnect();

			commit('updateMessage', { message: "Zoeken naar E-finder signaal..." });

			console.log('CONNECT', state.bleDevice);

			if(
				state.bleDevice &&
				state.bleDevice.name.substr(-6) == deviceId.substr(-6) &&
				await BleDeviceService.isConnected(state.bleDevice.id)
			) {
				console.log('ALREADY CONNECTED', state.bleDevice);
				return state.bleDevice;
			}

			try {
				advertisement = await BleDeviceService.find(deviceId);
				console.log('FOUND 1');
			} catch(error) {
				console.log('NOT FOUND');
				commit('updateError', { error: "BLE Error:" + error });
				throw 'Can\'t find E-Finder';
			}

			try {
				console.log('Start Connect');
				bleDevice = await BleDeviceService.connect(advertisement.id);
				console.log('Connected');
			} catch(error) {
				throw 'Can\'t connect to E-Finder';
			}

			commit('updateMessage', { message: "E-finder signaal sterkte" });

			BleDeviceService.startMeasuringRssi(bleDevice.id,
				rssi => {
					commit('updateRssi', { rssi: rssi });
				},() => {
					commit('updateRssi', { rssi: null });
					// dispatch('bleConnect', deviceId);
				});

			commit('updateBleDevice', { bleDevice: bleDevice });
			commit('updateRssi', { rssi: bleDevice.rssi });

			console.log('Complete connect');

			return bleDevice;
		},
		bleDisconnect({commit}){
			BleDeviceService.disconnect();
			commit('updateMessage', { message: "E-finder signaal onderbroken" });
			commit('updateRssi', { rssi: null });
			commit('updateBleDevice', { bleDevice: null });
		}
	},
	mutations: {
		// updateConnecting(state, payload) {
		// 	state.connecting = payload;
		// },
		resetBle(state) {
			state.rssi = null;
			state.bleDevice = null;
		},
		updateRssi(state, payload) {
			state.rssi = payload.rssi;
		},
		updateBleDevice(state, payload) {
			state.bleDevice = payload.bleDevice;
		},
		updateMessage(state, payload) {
			state.message = moment().format('HH:mm:ss') + ' ' + payload.message;
		},
		updateError(state, payload) {
			state.error = moment().format('HH:mm:ss') + ' ' + payload.error;
		}
	}
}
